import { GridLegacy as Grid, Stack, styled } from '@mui/material'
import { CaretDown } from '@phosphor-icons/react'
import { TinyButton, tokens } from 'ComponentLibrary'
import { useState } from 'react'
import { SensistivityMatrixLegendItem } from './SensitivityMatrixItem'
import type { SensitivityMatrixCopy } from './SensitivityMatrix'

// TODO: Replace Accordion component with something similar for piazza
export default function SensitivityMatrixLegend({ copy }: { copy: SensitivityMatrixCopy }) {
    const [isOpen, setIsOpen] = useState<boolean>(false)

    const handleClick = () => {
        setIsOpen(!isOpen)
    }

    const caretIcon = (
        <CaretAnimationWrapper className={isOpen ? 'open' : ''}>
            <CaretDown weight="bold" />
        </CaretAnimationWrapper>
    )

    return (
        <Stack direction="column" gap={tokens.SizingSpacing100} alignSelf="flex-start">
            <TinyButton label={copy.legendLabel} rightIcon={caretIcon} onClick={handleClick} />
            <MatrixItemAnimationWrapper className={isOpen ? 'open' : ''}>
                <SensistivityMatrixLegendItem copy={copy} />
            </MatrixItemAnimationWrapper>
        </Stack>
    )
}

const MatrixItemAnimationWrapper = styled(Stack)`
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.2s ease-in-out;

    &.open {
        max-height: 200px;
    }
`

const CaretAnimationWrapper = styled(Grid)`
    display: flex;
    align-items: center;
    transition: transform 0.2s ease-in-out;

    &.open {
        transform: rotate(180deg);
    }
`
